<template>
  <div class="container about-main">
    <div class="row">
      <div class="picture col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
        <img src="../assets/martinaboutimage.jpg" alt />
        <p>
          Marty is not new to the international vacation rental scene and
          welcomes you with his years of experience in offering elite properties
          at a great value for the ultimate vacation. Marty has owned property
          in Cabo since 1998. He then designed and built the 6-bedroom Villa
          Andaluza in 2007 and followed with the 8-bedroom Villa Veranza in
          2014, both in Pedregal, Cabo San Lucas.
        </p>
      </div>
      <div class="col-xl-1"></div>
      <div class="about-text col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12">
        <h1>About Us</h1>
        <p>
          One of the unique features of his Cabo luxury villas that you rarely
          find is professional in-house chef services, concierge and
          housekeeping included in the nightly rate! And that’s with the
          panoramic ocean views, private beach access, and much more included.
        </p>
        <p>
          And while Mexico is truly amazing, he’s not done there. Marty Wong is
          a proud native of Napa Valley, California, so he jets back up the west
          coast regularly as a real estate entrepreneur.
        </p>
        <p>
          Marty truly enjoyed creating all of his vacation properties and
          continues to be hands-on working with his team to help keep the
          properties ready for the next group of guests. He’s excited to share
          his vacation home and villas with you!
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "../styles/main";
.about-main {
  font-family: "Raleway", sans-serif;
  background-color: $bg--blue--light !important;
  padding: 20px;
}
.picture {
  height: auto;
  color: $text--blue--dark;
  img {
    width: 100%;
  }
  p {
    font-weight: 600;
    padding: 20px;
    @media only screen and (max-width: 1000px) {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
}
.about-text {
  color: $text--blue--dark;
  width: 200px;
  text-align: left;

  h1 {
    margin-top: 20px;
  }
  p {
    margin-right: 60px;
    font-weight: 600;
    @media only screen and (max-width: 1000px) {
      margin-right: 0px;
    }
  }
}
</style>
